import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addressHeader: {
    defaultMessage: 'Editing for this order is disabled.',
    description: 'edit address tooltip header message for fedexHAL orders',
    id: 'TsuWmX',
  },
  addressBody: {
    defaultMessage: 'This type of delivery must go to the address below.',
    description: 'edit address tooltip body message for fedexHAL orders',
    id: 'u9H2B/',
  },
  carrierHeader: {
    defaultMessage: 'Restricted Carrier Choices',
    description: 'edit carrier tooltip header message for fedexHAL orders',
    id: 'Yi2jks',
  },
  carrierBody: {
    defaultMessage: 'This order requires you only use FedEx as the carrier.',
    description: 'edit carrier tooltip body message for fedexHAL orders',
    id: 'KiL2JB',
  },
});
